import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NoResults } from '@flightstats/component-lib';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import moment from 'moment';

import { loadOTPByFlight } from '../redux/actions';
import componentBase from '../../../src/lib/component-base';
import PerformanceSegments from './children/MultiFlight/container';
import OnTimePerformanceDetail from './children/SingleFlight/container';
import Header from './shared/Header/Header';
import { addMetaCanonical } from '../../../shared/lib/meta-tags';
import getDateRangeRoutingsGoodFor from '../../../shared/lib/get-date-range-routings-good-for';
import BannerAd from '../../../shared/components/BannerAd/BannerAd';
import { dateFormatString } from '../../../src/lib/date-time-format';
import { OnTimePerformance as onTimePerformanceAds } from './ads';

@connect(state => ({
  loaded: state.OnTimePerformance.loaded,
  ratings: state.OnTimePerformance.ratings,
  user: state.Account.user,
}))
@componentBase('OnTimePerformance')
export default class OnTimePerformance extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    loaded: PropTypes.bool,
    location: PropTypes.object,
    match: PropTypes.object,
    params: PropTypes.object,
    ratings: PropTypes.array,
    routeParams: PropTypes.object,
    user: PropTypes.object,
  };

  componentDidMount() {
    const { ratings } = this.props;
    this.props.dispatch(loadOTPByFlight(this.props.match.params));

    if (ratings && ratings.length === 1) {
      const {
        departureAirport,
        arrivalAirport,
        airline,
        errorCode,
      } = ratings[0];
      if (!errorCode) {
        this.context.reportEvent('Airport', departureAirport.fs, 'Departing', null, true);
        this.context.reportEvent('Airport', arrivalAirport.fs, 'Arriving', null, true);
        this.context.reportEvent('Airline', airline.fs, null, null, true);
      }
    }
  }

  dateRange = (startRange, endRange, userPreference) => (
    <div className='date-range'>
      <span className='date-title'>Date Range:</span>
      <p className='date-subtitle'>
        {`${startRange.format(userPreference)} to ${endRange.format(userPreference)}`}
      </p>
    </div>
  );

  meta = (params, airline, location) => {
    const { flightNumber } = params;
    const carrierCode = this.carrierCode();
    const codeAndNumber = `${carrierCode} ${flightNumber}`;
    const nameAndNumber = `${airline && airline.name} ${flightNumber}`;

    const description = [
      'Check the historical on-time performance for flight ',
      `${carrierCode ? `(${carrierCode}) ` : ''}${airline && airline.name ? `${airline && airline.name} ${flightNumber} ` : ''}`,
      'to help avoid frequently delayed or cancelled flights',
    ].join(' ');

    const keywords = [
      `${codeAndNumber} on-time rating`,
      `${codeAndNumber} performance rating`,
      `${nameAndNumber} on-time rating`,
      `${nameAndNumber} performance rating`,
    ].join(', ');

    const title = `${carrierCode} ${nameAndNumber} On-time Performance Rating`;

    const meta = addMetaCanonical({
      title,
      meta: [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
      ],
    }, location && location.pathname);

    return meta;
  }

  errorText = () => {
    // leaving this here for possible expansion as needed
    const { ratings } = this.props;
    const errorTexts = {
      324: {
        heading: 'No Results For This Flight Number',
        sub: 'Sorry, we currently do not have an on-time performance rating for this flight',
      },
    };
    const errorCode = ratings && ratings[0] && ratings[0].errorCode;
    return errorTexts[errorCode] || errorTexts[324];
  }

  carrierCode = () => {
    const { match, ratings } = this.props;
    const { airline } = ratings && ratings.length ? ratings[0] : {};
    const { carrierCode } = match.params;
    return (airline && airline.fs) || carrierCode.toUpperCase();
  }

  render() {
    const {
      loaded,
      location,
      match,
      ratings,
      user,
    } = this.props;

    if (!loaded) {
      return (
        <div />
      );
    }

    const isSubscribed = user && user.subscriptionActive;
    const rating = ratings && ratings.length ? ratings[0] : {};
    const { airline, errorCode } = rating;
    const { flightNumber } = match.params;
    const carrierCode = this.carrierCode();

    const meta = this.meta(match.params, airline, location);

    let headerParams = {
      airlineName: airline && airline.name,
      carrierCode,
      flightNumber,
    };

    let child = (
      <OnTimePerformanceDetail
        rating={rating}
        subscribed={isSubscribed}
        carrierCode={carrierCode}
        flightNumber={flightNumber}
      />
    );

    let dateRange = null;

    if (!ratings || errorCode) {
      const { heading, sub } = this.errorText();
      child = (
        <NoResults
          headingText={heading}
          subText={sub}
        />);
    } else {
      const now = moment.utc(); // really does not matter what now or nowAgain are
      const nowAgain = now.clone(); // just need them to be moment objects
      const {
        startRange,
        endRange,
      } = getDateRangeRoutingsGoodFor(now, nowAgain);

      const userDateFormat = dateFormatString(user);
      dateRange = this.dateRange(startRange, endRange, userDateFormat);
    }
    if (ratings && ratings.length > 1) {
      headerParams = null;
      child = (
        <PerformanceSegments ratings={ratings} />
      );
    }

    return (
      <div>
        <Helmet {...meta} />
        <div style={{ margin: '20px 0' }} >
          <BannerAd
            topAd
            mobileAd={onTimePerformanceAds.bannerMobile}
            desktopAd={onTimePerformanceAds.banner}
            subscriptionActive={isSubscribed}
          />
          <Header params={headerParams} />
          {dateRange}
        </div>
        {child}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/components/container.js